import {UseFormReturnType} from "@mantine/form";
import {useTranslation} from "react-i18next";
import {Button, Divider, Grid, Switch, TextInput} from "@mantine/core";
import {useCallback} from "react";
import {useApp} from "../../../providers/RegionProvider/RegionProvider";
import {useServiceTypeForm} from "./useServiceTypeForm";

export interface ServiceTypeFormProps {
  options?: ServiceTypeFormOptions;
  defaultValues?: ServiceTypeFormDefaultValues;
  onSubmit?: (values: ServiceTypeFormValues) => void;
  submitting?: boolean;
}

export interface ServiceTypeFormOptions {

}

export interface ServiceTypeFormValues {
  type: string;
  abbr?: string;
  description?: string;
  doNotUse?: boolean
}

export interface ServiceTypeFormDefaultValues extends Partial<ServiceTypeFormValues> {

}

export interface ServiceTypeFormRawValues {
  type?: string;
  abbr?: string;
  description?: string;
  doNotUse?: boolean
}

export type ServiceTypeFormType = UseFormReturnType<ServiceTypeFormRawValues, (values: ServiceTypeFormRawValues) => ServiceTypeFormRawValues>

export const ServiceTypeForm = (props: ServiceTypeFormProps) => {
  const {
    options,
    defaultValues,
    onSubmit,
    submitting = false
  } = props;

  const region = useApp();

  const {t} = useTranslation(["common"]);

  const form = useServiceTypeForm({
    defaultValues: defaultValues,
  });

  const onFormSubmit = useCallback(async (values: typeof form.values) => {

    if (onSubmit) {
      onSubmit({
        type: values.type!,
        abbr: values.abbr,
        description: values.description,
        doNotUse: values.doNotUse,
      });
    }
  }, [form, onSubmit]);

  return (
    <form onSubmit={form.onSubmit(onFormSubmit)}>
      <Grid grow gutter="xs">
        <Grid.Col span={12}>
          <TextInput
            label={t("common.entity.servicetype.form.field.type", "Name")}
            placeholder={t<string>("common.entity.servicetype.form.field.type.placeholder", "Name")}
            withAsterisk
            required
            {...form.getInputProps("type")} />
        </Grid.Col>
        <Grid.Col span={12}>
          <TextInput
            label={t("common.entity.servicetype.form.field.abbr", "Abbreviation")}
            placeholder={t<string>("common.entity.servicetype.form.field.abbr.placeholder", "Abbreviation")}
            {...form.getInputProps("abbr")} />
        </Grid.Col>
      </Grid>
      <Divider my="sm" variant="dotted"/>
      <Switch
        label={t("common.entity.servicetype.form.field.donotuse", "Do Not Use")}
        placeholder={t<string>("common.entity.servicetype.form.field.donotuse", "Do Not Use")}
        {...form.getInputProps("doNotUse", {type: 'checkbox'})} />
      <Button type="submit" loading={submitting} fullWidth mt="xl">
        {t("common.action.submit", {ns: "common"})}
      </Button>
    </form>
  );
};
